module.exports = __webpack_public_path__ + "img/canary-islands.a51dd615.png";